import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/constants";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true }).then((res) => {
        if (res.data?.token) localStorage.setItem("rr_admin_token", res.data.token);
      });
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your email and password.");
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#EBEBFA] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="bg-white rounded-3xl shadow-sm p-10 max-w-md w-full">
        <h1 className="font-display text-3xl text-[#1A243B] mb-2">Owner sign in</h1>
        <p className="text-[#2D3748] text-sm mb-8">Bookings &amp; availability for Ready &amp; Right Testing Services.</p>
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label className="text-sm font-bold text-[#1A243B]">Email</Label>
            <Input data-testid="admin-email-input" type="email" className="bg-white border-[#1A243B]/15 rounded-xl h-12" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-bold text-[#1A243B]">Password</Label>
            <Input data-testid="admin-password-input" type="password" className="bg-white border-[#1A243B]/15 rounded-xl h-12" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <p className="text-red-600 text-sm font-semibold" data-testid="admin-login-error">{error}</p>}
          <button data-testid="admin-login-btn" disabled={loading} className="cta-pill w-full bg-[#FFC107] text-[#1A243B] font-bold py-3.5 rounded-full flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Sign in
          </button>
        </form>
        <Link to="/" data-testid="admin-back-home" className="block text-center text-sm text-[#2D3748] mt-6 hover:opacity-70">← Back to the site</Link>
      </div>
    </main>
  );
}
